import { DriverActivityType } from '@/modules/activities/consts'
import { useTheme } from 'styled-components'

export function useActivityColor() {
  const theme = useTheme()
  return (activity: {
    activityType: string
    excludeFromSalaryCalculation?: boolean
    excludeBefore?: string | null
    excludeAfter?: string | null
  }) => {
    if (
      activity.excludeFromSalaryCalculation &&
      !activity.excludeBefore &&
      !activity.excludeAfter
    ) {
      return theme.colors.red
    }
    switch (activity.activityType) {
      case DriverActivityType.WORK:
        return theme.colors.orange
      case DriverActivityType.AVAILABLE:
        return theme.colors.primary500
      case DriverActivityType.REST:
        return theme.colors.blue400
      case DriverActivityType.PAID_REST:
        return theme.colors.secondary500
      case DriverActivityType.DRIVE:
        return theme.colors.primary
      case 'Country':
        return theme.colors.tertiary
      default:
        return theme.colors.red
    }
  }
}
